module.exports = __webpack_public_path__ + "static/media/font-awesome.css.8d57a964.map";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome.css.map
// module id = 696
// module chunks = 36